import React from 'react'
import Loader from 'react-loader-spinner'

const OverlaySpinner = () => {
  return (
    <div className="overlay">
      <Loader
        className="spinner"
        type="Oval"
        color="white"
        height={50}
        width={50}
      />
    </div>
  )
}

export default OverlaySpinner
